import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Style from './BurgerMenuTitle.module.css'
import { useHistory } from "react-router-dom";

const BurgerMenuTitle = ({title,goHome=false}) => {
    let history = useHistory();
    return (
        <div className={Style.ComponentHolder}>
            <div></div>
            <h3>{title}</h3>
            <div style={{color:"black"}} onClick={() => goHome?window.open("barest.ir", "_self"):history.goBack()}><FontAwesomeIcon icon={faArrowRight} style={{fontSize:"1.4rem"}}/></div>
        </div>
    )
}

export default BurgerMenuTitle
 